import React from "react";
import { Card, Button, DatePicker, Badge, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";

const PM_Approval = () => {
  const navigate=useNavigate();
  return (
    <div style={{ padding: 20, background: "#f3f5f7", minHeight: "100vh" }}>
      {/* Header */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Row align="middle" gutter={10}>
            <Col>
<DatePicker.RangePicker picker="month" size="small" />
            </Col>
            <Col>
              <h3 style={{ marginLeft:15}}>PM Calulation  Approval Screen</h3>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            type="primary"
            style={{
              background: "#7E35FE",
              border: "none",
            }}
          >
            Export
          </Button>
        </Col>
      </Row>

      {/* Cards */}
      <Row gutter={24} justify="start">
        <Col>
          <Badge
            count="5 New"
            style={{
              backgroundColor: "#fff",
              color: "#000",
              border: "1px solid #000",
              fontWeight: 500,
            }}
            offset={[0, -10]}
          >
            <Card
              hoverable
              style={{
                width: 220,
                backgroundColor: "#5bb4ff",
                color: "#000",
                textAlign: "center",
                borderRadius: 8,
              }}
              bodyStyle={{ padding: 40 }}
              onClick={()=>navigate("/approvalscreens/pm-app")}
            >
              <b>Pending Approvals</b>
            </Card>
          </Badge>
        </Col>

        <Col>
          <Card
            hoverable
            style={{
              width: 220,
              backgroundColor: "#ffbe6b",
              color: "#000",
              textAlign: "center",
              borderRadius: 8,
            }}
            bodyStyle={{ padding: 40 }}
          >
            <b>L1 Approved</b>
          </Card>
        </Col>

        <Col>
          <Card
            hoverable
            style={{
              width: 220,
              backgroundColor: "#ff6b6b",
              color: "#000",
              textAlign: "center",
              borderRadius: 8,
            }}
            bodyStyle={{ padding: 40 }}
          >
            <b>Rejected</b>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PM_Approval;